export default "__VITE_ASSET__BpCkgos2__"